const sanitizeNumberString = (str) => {
  // Remove all standard spaces, non-breaking spaces, commas, and currency symbols
  return str
    .replace(/\s+/g, '')
    .replace(/\u00A0/g, '')
    .replace(/\u202F/g, '')
    .replace('€', '')
}

const searchInExpenseAndEcritures = (expenses, search) => {
  // Check if the search is a number
  if (!isNaN(search)) {
    // If it is, remove spaces and non-number characters
    search = sanitizeNumberString(search)
  }

  return (
    expenses
      .map((expense) => {
        // Search in expense properties
        let isExpenseMatch = false

        // New array for matching ecritures
        let matchingEcritures = []

        // Search in ecritures of each expense
        if (Array.isArray(expense.ecritures)) {
          for (let ecriture of expense.ecritures) {
            const ecritureLibelle =
              ecriture && ecriture.libelle ? ecriture.libelle.toLowerCase() : ''
            const ecritureDate =
              ecriture && ecriture.date ? ecriture.date.toLowerCase() : ''
            const ecritureMontant =
              ecriture && ecriture.montant
                ? new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                  })
                    .format(ecriture.montant / 100)
                    .toLowerCase()
                : ''
            const ecritureDeductible =
              expense && expense.deductible
                ? new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                  })
                    .format(ecriture.deductible / 100)
                    .toLowerCase()
                : ''
            const ecritureRecuperable =
              expense && expense.recuperable
                ? new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                  })
                    .format(ecriture.recuperable / 100)
                    .toLowerCase()
                : ''
            const ecritureTva =
              expense && expense.tva
                ? new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                  })
                    .format(ecriture.tva / 100)
                    .toLowerCase()
                : ''

            // If an ecriture matches the search term, add it to matchingEcritures and set isExpenseMatch to true
            if (
              ecritureLibelle.includes(search.toLowerCase()) ||
              ecritureDate.includes(search.toLowerCase()) ||
              sanitizeNumberString(ecritureMontant).includes(
                search.toLowerCase()
              ) ||
              sanitizeNumberString(ecritureDeductible).includes(
                search.toLowerCase()
              ) ||
              sanitizeNumberString(ecritureRecuperable).includes(
                search.toLowerCase()
              ) ||
              sanitizeNumberString(ecritureTva).includes(search.toLowerCase())
            ) {
              // Store the field(s) that matched the search
              let matchingFields = []
              if (ecritureLibelle.includes(search.toLowerCase()))
                matchingFields.push('libelle')
              if (ecritureDate.includes(search.toLowerCase()))
                matchingFields.push('date')
              if (
                sanitizeNumberString(ecritureMontant).includes(
                  search.toLowerCase()
                )
              )
                matchingFields.push('montant')
              if (
                sanitizeNumberString(ecritureDeductible).includes(
                  search.toLowerCase()
                )
              )
                matchingFields.push('deductible')
              if (
                sanitizeNumberString(ecritureRecuperable).includes(
                  search.toLowerCase()
                )
              )
                matchingFields.push('recuperable')
              if (
                sanitizeNumberString(ecritureTva).includes(search.toLowerCase())
              )
                matchingFields.push('tva')

              // Add the ecriture to matchingEcritures with its matching fields
              matchingEcritures.push({ ...ecriture, matchingFields })

              isExpenseMatch = true
            }
          }
        }

        // If the expense matched the search, return a new expense object that includes only the matching ecritures
        if (isExpenseMatch) {
          return { ...expense, ecritures: matchingEcritures }
        } else {
          return null
        }
      })
      // Remove any null entries from the array (i.e., expenses that didn't match the search)
      .filter((expense) => expense !== null)
  )
}

export default searchInExpenseAndEcritures
